import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import VoipOrderForm from '../forms/VoipOrderForm'
import globals from '../globals'

class VoipModule extends React.Component {
    handleSuccess (response, state) {
        globals.pushEvent(this.props.eventName, { planName: state.planObj.title })
    }

    render () {
	    const NotAvailable = <p className='text-center'>Your account is not eligible for this product.</p>

        return (
            <div className='voip-module module'>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title={this.props.title} />
                <ModuleWithLoader isLoaded={this.props.isLoaded} hasError={this.props.hasError}>
                    <div className='row p-4'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            {this.props.addresses.length > 0
                                ? <VoipOrderForm
                                        isTransfer={this.props.isTransfer}
                                        includes={this.props.includes}
                                        type={this.props.type}
                                        addresses={this.props.addresses}
                                        plans={this.props.plans}
                                        handleSuccess={this.handleSuccess.bind(this)}
                                  />
                                : NotAvailable}
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

VoipModule.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    addresses: PropTypes.array.isRequired,
    plans: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    isTransfer: PropTypes.bool,
    type: PropTypes.oneOf(['transfer', 'new-order']).isRequired,
    includes: PropTypes.string,
    eventName: PropTypes.string
}

export default VoipModule



// WEBPACK FOOTER //
// ./resources/js/modules/VoipModule.js